var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_163897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 16.6641V11.6641H13.334V16.6641H15.834V3.33073H4.16732V16.6641H6.66732ZM8.33398 16.6641H11.6673V13.3307H8.33398V16.6641ZM17.5006 16.6641H19.1673V18.3307H0.833984V16.6641H2.50065V2.4974C2.50065 2.27638 2.58845 2.06442 2.74473 1.90814C2.90101 1.75186 3.11297 1.66406 3.33398 1.66406H16.6673C16.8883 1.66406 17.1003 1.75186 17.2566 1.90814C17.4129 2.06442 17.5006 2.27638 17.5006 2.4974V16.6641ZM9.16732 6.66406V4.9974H10.834V6.66406H12.5007V8.33073H10.834V9.9974H9.16732V8.33073H7.50065V6.66406H9.16732Z",
    fill: "#002244"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_163897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgClinic);
export default __webpack_public_path__ + "static/media/svg_clinic.4b5f3a849b2fd10294d6909203698851.svg";
export { ForwardRef as ReactComponent };